import { DeductionRequestStatus, DeductionRequestType } from '@aslanpay/portal-common-lib';

export const DeductionRequestTypeLabels: Record<DeductionRequestType, string> = {
  RESERVE: 'Set & Spend',
  SAVINGS: 'Savings',
};

const DeductionRequestsCategoryValues: Record<
  DeductionRequestStatus,
  { color: string; value: string }
> = {
  REQUESTED: {
    color: 'registered',
    value: 'Requested',
  },
  PENDING: {
    color: 'created',
    value: 'Pending',
  },
  COMPLETED: {
    color: 'active',
    value: 'Completed',
  },
  CANCELLED: {
    color: 'paused',
    value: 'Cancelled',
  },
  AVAILABLE: {
    color: 'active',
    value: 'Available',
  },
  ACTION_REQUIRED: {
    color: 'warning',
    value: 'Action required',
  },
};

export default DeductionRequestsCategoryValues;
